import { UserEventType } from '@shared/core/user-events'
import { useMemo } from 'react'
import { useListUserEvents } from './use-list-user-events'

export function useHasUserEvent(eventName: UserEventType, afterDate?: Date) {
  const { data: userEvents, isLoading, isError, ...rest } = useListUserEvents()

  const hasEvent = useMemo(() => {
    if (isLoading || isError) return null
    return (
      userEvents?.some((event) => {
        return event.event === eventName && (!afterDate || new Date(event.timestamp).getTime() > afterDate.getTime())
      }) ?? false
    )
  }, [userEvents, eventName, isLoading, isError, afterDate])

  return {
    data: hasEvent,
    isLoading,
    isError,
    ...rest,
  }
}
